"use strict";
var parser = require("./parser")["default"];
var AST = require("./ast")["default"];

exports.parser = parser;

function parse(input) {
  // Just return if an already-compile AST was passed in.
  if(input.constructor === AST.ProgramNode) { return input; }

  parser.yy = AST;
  return parser.parse(input);
}

exports.parse = parse;


//////////////////
// WEBPACK FOOTER
// ../node_modules/handlebars/dist/cjs/handlebars/compiler/base.js
// module id = 100
// module chunks = 0 1